// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-content--Dx8zy{display:flex;align-items:center;justify-content:center;height:150px}", "",{"version":3,"sources":["webpack://./src/pages/SalesOrders/components/SalesOrderPayload/detail-container.module.scss"],"names":[],"mappings":"AAAA,mBACE,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,YAAA","sourcesContent":[".no-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-content": "no-content--Dx8zy"
};
export default ___CSS_LOADER_EXPORT___;
